import 'scss/services/eHistory.scss'
import 'babel-polyfill'
import {
  serviceQA,
  serviceTopbar
} from 'js/libs/utils-services'
import { config } from 'config'
import * as userApi from 'js/api/user'
import { showLoginModal } from 'js/libs/utils-login'
$(function () {
  serviceQA()
  serviceTopbar()
  $('#applyNow').click(function () {
    userApi.checkLogin().then(result => {
      if (result.code === 80000) {
        showLoginModal()
      } else {
        window.open(`${config.CONSOLE}workorder/commit?category=fd5bd34ed0cf46819bb2de6d47eca75a&tid=ca467c0f653049ee889e5ab3c4d510b6&categoryName=口腔语音电子病历&tname=商务接洽&title=口腔语音电子病历 - 服务申请&id=eHistory`)
      }
    })
  })
})



// WEBPACK FOOTER //
// ./src/js/entry/services/eHistory.js